// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.multiselect[data-v-0b72cbf8], input[type='text'][data-v-0b72cbf8] {\n\twidth: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
